var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAustralia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39123_442699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H26.6667V20H0V0Z",
    fill: "#00008B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5625 0L6.64583 3.77083L11.7083 0H13.3333V1.29167L8.33333 5.02083L13.3333 8.72917V10H11.6667L6.66667 6.27083L1.6875 10H0V8.75L4.97917 5.04167L0 1.33333V0H1.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83333 5.85417L13.3333 9.16667V10L7.6875 5.85417H8.83333ZM5 6.27083L5.125 7L1.125 10H0L5 6.27083ZM13.3333 0V0.0625L8.14583 3.97917L8.1875 3.0625L12.2917 0H13.3333ZM0 0L4.97917 3.66667H3.72917L0 0.875V0Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02083 0V10H8.35417V0H5.02083ZM0 3.33333V6.66667H13.3333V3.33333H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.02083V6.02083H13.3333V4.02083H0ZM5.6875 0V10H7.6875V0H5.6875Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9587 16.5307L21.1046 16.6391L21.1962 17.4932L20.5796 16.8932L19.9671 17.4974L20.0504 16.6432L19.1962 16.5432L19.9171 16.0766L19.4629 15.3474L20.2796 15.6182L20.5671 14.8057L20.8629 15.6141L21.6754 15.3349L21.2296 16.0682L21.9587 16.5307ZM21.8046 11.6474L21.9171 11.1057L21.5087 10.7307L22.0587 10.6682L22.2879 10.1641L22.5171 10.6682L23.0671 10.7307L22.6587 11.1057L22.7712 11.6474L22.2879 11.3724L21.8046 11.6474ZM17.4671 9.1474L16.6212 9.23906L16.6962 10.0849L16.0962 9.48073L15.4796 10.0682L15.5796 9.2224L14.7379 9.1099L15.4587 8.6599L15.0212 7.93073L15.8254 8.21406L16.1254 7.41823L16.4046 8.2224L17.2129 7.9599L16.7587 8.68073L17.4712 9.1474H17.4671ZM25.9587 7.78073L25.0879 7.89323L25.1837 8.76406L24.5546 8.15156L23.9296 8.76823L24.0171 7.89323L23.1462 7.79323L23.8837 7.31406L23.4212 6.56823L24.2546 6.8474L24.5462 6.0224L24.8462 6.8474L25.6754 6.5599L25.2171 7.3099L25.9587 7.78073ZM21.9546 4.30156L21.0921 4.3974L21.1712 5.26406L20.5587 4.6474L19.9296 5.2474L20.0296 4.3849L19.1671 4.26823L19.9046 3.8099L19.4587 3.06406L20.2796 3.35156L20.5837 2.53906L20.8671 3.3599L21.6921 3.08906L21.2296 3.8224L21.9546 4.30156ZM9.75039 16.0724L7.84206 16.2974L8.03372 18.2099L6.66706 16.8599L5.29206 18.2016L5.49622 16.2891L3.58789 16.0474L5.20872 15.0141L4.20872 13.3724L6.02539 13.9974L6.68372 12.1891L7.32956 14.0016L9.15039 13.3891L8.13789 15.0224L9.75456 16.0682L9.75039 16.0724Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39123_442699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6667,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustralia);
export default __webpack_public_path__ + "static/media/australia.b3f103380795a3904c5bcf6cdb09dfd2.svg";
export { ForwardRef as ReactComponent };